import { ArrowUpRight, BookOpenText, ChatCircleText, Check, Copy, FileText, MagnifyingGlass } from "@phosphor-icons/react";
import { prompts, toolItems, type Locale } from "../data";

const icons = [ChatCircleText, MagnifyingGlass, FileText, BookOpenText];

type ToolsSectionProps = {
  locale: Locale;
  copyText: (text: string, key: string) => Promise<void>;
  copiedKey: string | null;
};

export function ToolsSection({ locale, copyText, copiedKey }: ToolsSectionProps) {
  const promptByTool = new Map(prompts.map((prompt) => [prompt.tool, prompt]));

  return (
    <div className="tools-grid">
      {toolItems.map((tool, index) => {
        const Icon = icons[index];
        const example = promptByTool.get(tool.name);
        const key = `prompt-${tool.name}`;

        return (
          <article className="tool-card" key={tool.name}>
            <div className="tool-card-heading">
              <Icon size={26} />
              <ArrowUpRight size={16} aria-hidden="true" />
            </div>
            <div>
              <code>{tool.name}</code>
              <h3>{tool.title[locale]}</h3>
              <p>{tool.description[locale]}</p>
            </div>
            {example ? (
              <div className="tool-example">
                <span>{example.title[locale]}</span>
                <p>{example.prompt[locale]}</p>
                <button className="copy-control" onClick={() => copyText(example.prompt[locale], key)} type="button">
                  {copiedKey === key ? <Check size={16} /> : <Copy size={16} />}
                  {copiedKey === key
                    ? (locale === "en" ? "Copied" : "已复制")
                    : (locale === "en" ? "Copy example" : "复制示例")}
                </button>
              </div>
            ) : null}
          </article>
        );
      })}
    </div>
  );
}
